export function secondsToString(t) {
  if (t < 0) {
    return '00:00'
  } else {
    return (
      '0' +
      Math.floor(t / 60).toString() +
      ':' +
      Math.floor(t % 60)
        .toString()
        .padStart(2, '0')
    )
  }
}

export function secondsToFullString(t) {
  const minutesValue = Math.floor(t / 60)
  const secondsValue = Math.floor(t % 60)
  const minutes = minutesValue
    ? `${minutesValue} minute${minutesValue !== 1 ? 's' : ''}`
    : null
  const seconds = `${secondsValue} second${secondsValue !== 1 ? 's' : ''}`

  return minutes ? [minutes, seconds].join(', ') : seconds
}
